module.exports = __webpack_public_path__ + "img/1504801723.9de8ad41.jpg";